import { Injectable, inject } from '@angular/core';
import {NetworkService} from '../../../../../../projects/common/src/lib/services/network.service';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';


@Injectable({
  providedIn: 'root',
})
export class NotificationsApiService extends BaseApiService {

  constructor() {

    super();
  }

  setNotificationsSeen(): Promise<any> {
    return this.put('/notifications/seen', {});
  }

  setNotificationRead(id: string): Promise<any> {
    return this.put(`/notifications/${encodeURIComponent(id)}/read`, {});
  }

  setNotificationsRead(): Promise<any> {
    return this.put('/notifications/read', {});
  }

}
